import { Component, OnInit, Input } from '@angular/core';
import { ElementSidebarService } from '../../element-sidebar/element-sidebar.service';
import { RouterService } from '../../../../utilities/router/router.service';
import { ProjectElement } from '../../project-element.interface';
import { ModuleService } from '../../../module/module.service';
import { SubmoduleService } from '../../../submodule/submodule.service';
import { ProjectModule } from '../../../module/project-module.interface';
import { ProjectSubmodule } from '../../../submodule/project-submodule.interface';

@Component({
  selector: 'sg2-element-form-breadcrumbs',
  templateUrl: './element-form-breadcrumbs.component.html',
  styleUrls: ['./element-form-breadcrumbs.component.less']
})
export class ElementFormBreadcrumbsComponent {

  /** Active element. */
  @Input() element: ProjectElement;

  /** Display. */
  @Input() display: 'page' | 'column';

  constructor(
    private elementSidebarService: ElementSidebarService,
    private moduleService: ModuleService,
    private routerService: RouterService,
    private submoduleService: SubmoduleService
  ) { }

  /**
   * Get module name.
   *
   * @returns Module name.
   */
  public getModuleName(): ProjectModule['name'] {
    return this.moduleService.getName(this.element.moduleId);
  }

  /**
   * Get submodule name.
   *
   * @returns Submodule name.
   */
  public getSubmoduleName(): ProjectSubmodule['name'] {
    return this.submoduleService.getName(this.element.submoduleId);
  }

  /**
   * Go to element page.
   *
   * @param type Element location type.
   * @param element The element to display on a full page.
   */
  public goToElement(type: 'area' | 'basicArea' | 'detail' | 'pve'): void {
    this.elementSidebarService.dismiss();
    this.routerService.goToElement(this.element, type);
  }
}
